/*
 * localStorage.js 12.06.18
 *
 * (c) 2018 ergovia GmbH
 */
/* global localStorage */

/**
 * Lädt den persistierten Redux-State aus dem LocalStorage und gibt ihn zurück.
 *
 * @return {Object|undefined} der desirialisierte Redux-State, oder undefined wenn bisher noch kein State persistiert.
 */
export const loadState = () => {

    // Try-Catch weil der Privacy-Mode im Browser die Benutzung von localStorage unterbindet und dann eine Exception schmeißt
    try {

        const serializedState = localStorage.getItem('state');

        if (serializedState === null) {

            // explizit undefined zurückgeben, damit redux den state aus den reducern herstellen kann, falls bisher kein state gespeichert wurde
            // eslint-disable-next-line no-undefined
            return undefined;
        }

        return JSON.parse(serializedState);

    } catch (err) {
        // explizit undefined zurückgeben, damit redux den state aus den reducern herstellt, falls der localStorage nicht verfügbar ist
        // eslint-disable-next-line no-undefined
        return undefined;
    }

};

/**
 * Speichert den übergebenen State im localStorage
 *
 * @param {Object} state der State der persistiert werden soll
 */
export const saveState = state => {

    try {

        const serializedState = JSON.stringify(state);

        localStorage.setItem('state', serializedState);

    } catch (err) {
        // LocalStorage ist nicht verfügbar. Das darf ruhig auf die console geloggt werden
        // eslint-disable-next-line no-console
        console.error(err);
    }

};



// WEBPACK FOOTER //
// ./src/de/ergovia/localStorage.js